/*global SunergoPlatform*/

const inputEvents = SunergoPlatform.inputEvents;

/**
 * Character limit field indicator.
 * @param {object} form - the form item.
 */
const initCharacterLimits = function(form) {
	const maxLengthFields = form.element.querySelectorAll('[maxlength], [data-maxlength]');
	if (!maxLengthFields || maxLengthFields.length < 1) return;

	maxLengthFields.forEach(function(input) {
		const field = input.closest('.sp-field');
		const feedback = field.querySelector('[data-character-limit]');
		if (!feedback) return;

		const maxLength = input.dataset.maxlength || input.maxLength;
		const limitMsg = {
			threshold: feedback.dataset.threshold,
			used: feedback.dataset.i18nUsed
		};

		/**
		 * Update the character counter.
		 * @param {HTMLElement} input - the input element.
		 */
		function updateCounter(input) {
			const currLength = input.value.length;
			const showCounter = currLength >= limitMsg.threshold;

			// Hide feedback if below threshold.
			feedback.hidden = !showCounter;

			// Enable aria live when above threshold.
			feedback.setAttribute('aria-live', showCounter ? 'polite' : 'off');

			// When at or above threshold, update counter.
			// When under threshold, clear counter.
			feedback.innerHTML = showCounter ? `${currLength}/${maxLength}` : '';

			if (showCounter) {
				// Update aria label.
				const ariaLabel = limitMsg.used
					.replace('{{used}}', currLength)
					.replace('{{limit}}', maxLength);
				feedback.setAttribute('aria-label', ariaLabel);
				feedback.setAttribute('title', ariaLabel);
			}
		}

		// Update the character counter on initialization.
		updateCounter(input);

		// Update the character counter on each change of input value.
		for (let event in inputEvents) {
			input.addEventListener(inputEvents[event], function() {
				updateCounter(input);
			});
		}

		// On Input Blur, turn off aria live for character counter.
		input.addEventListener('blur', function() {
			feedback.setAttribute('aria-live', 'off');
		});
	});
};

export default initCharacterLimits;